<template>
  <div class="flex">
    <SideBar />
    <div
      v-if="pollData == null"
      class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-[28px] overflow-x-auto overflow-y-auto !h-[calc(100vh-170px)] bg-white"
      style="box-shadow: 0px 2px 30px 0px #01b0f926"
    >
      <div class="p-4 sm:p-6 md:p-10 flex flex-col gap-5 sm:gap-6">
        <header class="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <h1
              class="font-semibold text-lg sm:text-xl tracking-tight text-[#12172B] mt-2"
            >
              Lesson Polls
            </h1>
            <p class="mt-1.5 text-sm text-[#5B6478]" v-if="!loading">
              {{ pollList.length }} poll{{ pollList.length === 1 ? "" : "s" }}
              recorded for this course
            </p>
          </div>

          <button
            v-if="pollList.length > 0"
            @click="polldownload()"
            class="bg-blues hover:bg-hover w-full sm:w-auto justify-center text-white rounded-2xl py-2 sm:py-1.5 px-5 flex items-center gap-2 cursor-pointer"
          >
            <svg
              class="w-[18px] h-[18px] flex-shrink-0"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 3v12m0 0-4-4m4 4 4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>Download all</span>
          </button>
        </header>

        <transition name="poll-fade">
          <div
            v-if="response_message"
            class="flex items-center gap-2.5 bg-[#EAF1FF] text-[#1747C7] rounded-[10px] px-4 py-3 text-sm flex-wrap sm:flex-nowrap"
          >
            <svg
              class="w-[15px] h-[15px] flex-shrink-0"
              viewBox="0 0 24 24"
              fill="none"
            >
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke="currentColor"
                stroke-width="1.8"
              />
              <path
                d="M9 12.5l2 2 4.5-5"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p class="m-0 flex-1 min-w-[160px]">{{ response_message }}</p>
            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="font-bold text-sm underline whitespace-nowrap"
            >
              Download history
            </router-link>
          </div>
        </transition>

        <div v-if="loading" class="flex flex-col gap-3">
          <div
            v-for="n in 3"
            :key="n"
            class="h-[58px] rounded-2xl bg-[length:400%_100%] bg-gradient-to-r from-[#F5F7FC] via-[#edf1fa] to-[#F5F7FC] animate-[poll-shimmer_1.4s_ease_infinite]"
          ></div>
        </div>

        <div v-else>
          <ul
            v-if="!loading && this.pollList.length > 0"
            class="list-none m-0 p-0 flex flex-col gap-2.5"
          >
            <li
              v-for="poll in pollList"
              :key="poll"
              @click="getDataofPoll(poll.lesson.id)"
              class="group relative flex items-center w-full lg:w-3/4 gap-2.5 sm:gap-3.5 bg-[#F5F7FC] border border-[#E6E9F3] rounded-2xl pl-4 sm:pl-5 pr-3 sm:pr-4 py-3 sm:py-3.5 cursor-pointer overflow-hidden transition-all duration-150 hover:bg-white hover:border-[#2F6FED] hover:-translate-y-px hover:shadow-[0_10px_22px_-14px_rgba(23,71,199,0.5)]"
            >
              <span
                class="absolute left-0 top-0 bottom-0 w-1 bg-[#2F6FED] scale-y-0 origin-center transition-transform duration-150 group-hover:scale-y-100"
              ></span>

              <span
                class="flex-shrink-0 grid place-items-center w-[34px] h-[34px] sm:w-[38px] sm:h-[38px] rounded-[11px] bg-[#EAF1FF] text-[#1747C7]"
              >
                <svg
                  class="w-[16px] h-[16px] sm:w-[18px] sm:h-[18px]"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 19V9m6 10V4m6 15v-7"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>

              <span class="flex-1 min-w-0 flex flex-col gap-0.5">
                <span class="font-bold text-sm text-[#12172B] truncate">{{
                  poll.lesson.title
                }}</span>
                <span
                  class="text-xs sm:text-sm text-[#9AA2B8] hidden xs:block sm:block"
                  >Tap to view results</span
                >
              </span>

              <button
                @click.stop="singledownload(poll.lesson.id)"
                class="p-2 sm:p-2.5 rounded-full bg-[#F5F7FC] text-[#12172B] hover:bg-[#EAF1FF] hover:text-[#1747C7] transition active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#2F6FED] focus-visible:outline-offset-2 flex-shrink-0"
                aria-label="Download this poll's results"
              >
                <svg
                  class="w-[14px] h-[14px] sm:w-[15px] sm:h-[15px]"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 3v12m0 0-4-4m4 4 4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <svg
                class="w-[16px] h-[16px] sm:w-[17px] sm:h-[17px] text-[#9AA2B8] flex-shrink-0"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9 6l6 6-6 6"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </li>
          </ul>

          <div
            v-else
            class="flex flex-col items-center text-center gap-1.5 py-14 px-5 text-[#5B6478]"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              class="w-[34px] h-[34px] text-[#9AA2B8] mb-1.5"
            >
              <path
                d="M4 19V9m6 10V4m6 15v-7"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p class="font-['Sora'] font-bold text-sm text-[#12172B] m-0">
              No data found
            </p>
            <p class="text-sm max-w-[280px] m-0">
              Results will show up here once a lesson poll gets responses.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="pollData != null"
      class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-[28px] overflow-x-auto overflow-y-auto !h-[calc(100vh-170px)] bg-white"
      style="box-shadow: 0px 2px 30px 0px #01b0f926"
    >
      <div class="p-4 sm:p-6 md:p-10 flex flex-col gap-5 sm:gap-6">
        <header class="flex items-start justify-end gap-4 flex-wrap -mb-1.5">
          <button
            class="bg-blues hover:bg-hover w-full sm:w-auto justify-center text-white rounded-2xl py-2 sm:py-1.5 px-5 flex items-center gap-2 cursor-pointer"
            @click="
              pollData = null;
              student_list = [];
              currentIndex = null;
            "
          >
            <svg class="w-[15px] h-[15px]" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 6l-6 6 6 6"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>Back</span>
          </button>
        </header>

        <div
          class="bg-gradient-to-br from-[#EAF1FF] to-white border border-[#E6E9F3] rounded-[20px] px-4 sm:px-6 py-4 sm:py-5"
        >
          <span
            class="block font-mono text-xs sm:text-sm font-semibold tracking-[0.14em] uppercase text-[#2F6FED] mb-1.5"
          >
            Question :
          </span>
          <h1
            class="font-lightbold text-sm leading-[1.4] text-[#12172B] my-1 mb-2.5 break-words"
          >
            {{ pollData.question }}
          </h1>
        </div>

        <ul class="list-none m-0 p-0 grid grid-cols-1 md:grid-cols-2 gap-3">
          <li
            v-for="(option, index) in pollData.options"
            :key="option"
            class="relative flex flex-col rounded-2xl p-3.5 sm:p-4 cursor-pointer transition-all duration-150 hover:-translate-y-0.5 hover:shadow-[0_12px_24px_-16px_rgba(18,23,43,0.35)]"
            :class="
              option.student_list.length > 0 &&
              option.student_list.length ===
                Math.max(...pollData.options.map((o) => o.student_list.length))
                ? 'border-[1.5px] border-[#16A34A] bg-[#E8F8EE]'
                : 'border-[1.5px] border-[#E6E9F3] bg-[#F5F7FC]'
            "
            @click="getStudentofPoll(option.student_list, index)"
          >
            <div class="flex items-center gap-2 sm:gap-2.5 mb-2.5 flex-wrap">
              <span
                class="font-mono text-sm font-bold text-[#5B6478] bg-white border border-[#E6E9F3] rounded-md w-[22px] h-[22px] grid place-items-center flex-shrink-0"
              >
                {{ index + 1 }}
              </span>
              <span
                class="font-bold text-sm text-[#12172B] flex-1 min-w-[80px] break-words"
                >{{ option.text }}</span
              >
              <span
                v-if="
                  option.student_list.length > 0 &&
                  option.student_list.length ===
                    Math.max(
                      ...pollData.options.map((o) => o.student_list.length),
                    )
                "
                class="font-mono text-xs sm:text-sm font-bold tracking-wider uppercase text-white bg-[#16A34A] px-2 py-0.5 rounded-full"
              >
                Leading
              </span>
              <span class="font-mono font-semibold text-sm text-[#5B6478]">{{
                option.student_list.length
              }}</span>
            </div>

            <div class="h-2 rounded-full bg-[#E6E9F3] overflow-hidden">
              <div
                class="h-full rounded-full transition-[width] duration-[400ms] ease-out"
                :class="
                  option.student_list.length > 0 &&
                  option.student_list.length ===
                    Math.max(
                      ...pollData.options.map((o) => o.student_list.length),
                    )
                    ? 'bg-gradient-to-r from-[#34D17C] to-[#16A34A]'
                    : 'bg-gradient-to-r from-[#2F6FED] to-[#1747C7]'
                "
                :style="{
                  width:
                    (pollData.options.reduce(
                      (a, o) => a + o.student_list.length,
                      0,
                    )
                      ? (option.student_list.length /
                          pollData.options.reduce(
                            (a, o) => a + o.student_list.length,
                            0,
                          )) *
                        100
                      : 0) + '%',
                }"
              ></div>
            </div>

            <button
              class="mt-3.5 self-start inline-flex items-center gap-2 font-semibold text-sm rounded-full bg-transparent text-[#1747C7] border-[1.5px] border-[#E6E9F3] px-3.5 py-2 hover:border-[#2F6FED] hover:bg-[#EAF1FF] transition active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#2F6FED] focus-visible:outline-offset-2"
            >
              View answered students
              <svg class="w-[15px] h-[15px]" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 6l6 6-6 6"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </li>
        </ul>

        <transition name="poll-fade">
          <div
            class="border-t border-dashed border-[#E6E9F3] pt-5 flex flex-col gap-3"
            v-if="currentIndex !== null"
          >
            <h2 class="font-lightbold text-sm text-[#12172B] m-0">
              Option {{ currentIndex + 1 }}
              <span class="font-normal font-['Inter'] text-[#9AA2B8]"
                >&middot; answered students</span
              >
            </h2>

            <ul
              class="list-none m-0 p-0 flex flex-col gap-2"
              v-if="student_list.length"
            >
              <li
                v-for="(student, index) in student_list"
                :key="index"
                class="flex items-center gap-3 bg-[#F5F7FC] border border-[#E6E9F3] rounded-[10px] px-3 sm:px-3.5 py-2.5"
              >
                <span
                  class="flex-shrink-0 w-8 h-8 rounded-full grid place-items-center font-['Sora'] font-bold text-sm text-white bg-gradient-to-br from-[#2F6FED] to-[#1747C7]"
                >
                  {{ (student.name || "?").charAt(0).toUpperCase() }}
                </span>
                <span class="flex flex-col gap-0.5 min-w-0">
                  <span
                    v-if="student.name"
                    class="font-bold text-sm text-[#12172B] truncate"
                    >{{ student.name }}</span
                  >
                  <span
                    v-if="student.remark"
                    class="text-sm text-[#5B6478] truncate"
                    >{{ student.remark }}</span
                  >
                </span>
              </li>
            </ul>
            <p v-else class="text-sm text-[#9AA2B8] px-0.5 py-1.5 m-0">
              No student answered
            </p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Instructor/SideBar.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    SideBar,
  },
  data() {
    return {
      pollList: [],
      pollData: null,
      student_list: [],
      currentIndex: null,
      response_message: "",
      loading: false,
    };
  },

  props: ["course_id"],

  async created() {
    this.detailsgets();
  },

  mounted() {},

  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    getStudentofPoll(list, index) {
      this.student_list = [];
      this.student_list = list;
      this.currentIndex = index;
    },

    async getDataofPoll(id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/poll/list/?lesson__course_name__id=${this.course_id}&Key=${this.userInfo.token_key}&lesson__id=${id}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.pollData = response.data.data[0];
          } else {
            console.log("No data found.");
          }
        });
    },

    async detailsgets() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/poll/list/?lesson__course_name__id=${this.course_id}&Key=${this.userInfo.token_key}`,
        );

        if (response.data.status == 200) {
          this.pollList = response.data.data;
        }
      } catch (e) {
        console.log("Error:", e);
      } finally {
        this.loading = false;
      }
    },
    async polldownload() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/polls/csv/generate/${this.course_id}/?Key=${this.userInfo.token_key}`,
        )
        .then((resp) => {
          if (resp) {
            this.response_message =
              "Your file is ready to download go to download history page";

            setTimeout(() => {
              this.response_message = "";
            }, 5000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async singledownload(id) {
      try {
        const resp = await axios.get(
          `${process.env.VUE_APP_API}/polls/download/?course_id=${this.course_id}&lesson_id=${id}&Key=${this.userInfo.token_key}`,
        );

        if (resp && resp.data.status == 200 && resp.data.download_link) {
          const link = document.createElement("a");
          link.href = resp.data.download_link;
          link.download = "";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } catch (err) {
        console.error("Download error:", err);
      }
    },
  },
};
</script>

<style scoped>
@keyframes poll-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.poll-fade-enter-active,
.poll-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.poll-fade-enter-from,
.poll-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

:deep(.video-container iframe) {
  width: 100% !important;
  height: auto !important;
  aspect-ratio: 16 / 9;
  max-height: 500px;
}
</style>
